Vue.component('nodo-menu', {
  name: 'nodo-menu',
  props: ['currentnodo', 'options'],
  template: '<div v-if="isActive">' +
    '<div v-if="currentnodo.msg.text" v-bind:class="currentnodo.from">' +
    '<div class="row bubble-agent col-xs-11">' +
    '<div class="col-xs-3 text-center"><img class="img-agent" :src="getImgAgent(currentnodo.agentType)"  :class="setClassAgent(currentnodo.agentType)" onerror="svgOnError()"><span v-if="timeShow" class="time">{{ currentnodo.currentTime }}</span></div>' +
    '<div class="col-xs-9 no-gutters"><div class="msg-text" v-html="currentnodo.msg.text"></div><p class="name">{{ currentnodo.name }}</span></p>' +
    '</div>' +
    '</div>' +
    '<div class="swiper-container nodo-menu-slide" v-bind:id="currentID" v-if="templateSlider" >' +
    '<div class="swiper-wrapper">' +
    '<div class="swiper-slide" v-for="(item,index) in nodoMenuObject">' +
    '<div class="row" @click="callLink(item,currentID)">' +
    '<div v-if="item.image_url" class="thumb" :style="getUrlBgImg(item.image_url)"><a v-if="hasImgLink(item.media_url)" :style="getHeightImg()"  :href="item.image_url | checkIfImgBase64" target="_blank"></a></div>' +
    '<div v-else class="thumb empthy" ><a v-if="hasImgLink(item.media_url)" :style="getHeightImg()"  :href="item.image_url | checkIfImgBase64" target="_blank"></a></div>' +
    '<h3 v-if="item.text" class="title-slide text-left" :title="this.titleTooltipTit" >{{ item.text | truncateTitle }}</h3>' +
    '<h3 v-else="item.caption" class="title-slide text-left" :title="item.caption" >{{ item.caption | truncateCaption }}</h3>' +
    '<button v-if="item.caption" class="btn btn-media" :title="item.caption"><img v-if="item.icon_url" class="iconurl" :src="item.icon_url">{{ item.caption | truncateCaption }}</button>' +
    '<button v-else="item.text" class="btn btn-media" :title="item.text"><img v-if="item.icon_url" class="iconurl" :src="item.icon_url"> + </button>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '<div class="swiper-pagination2" v-if="pagination"></div>' +
    '<div class="swiper-button-next2" v-if="swipeNext"></div>' +
    '<div class="swiper-button-prev2" v-if="swipePrev"></div>' +
    '</div>' +
    '<div class="box-nodo-menu nodo-menu-label text-center offset-top-10" v-bind:id="currentID" v-if="templateMenu" >' +
    '<div v-for="(item,index) in nodoMenuObject" @click="callLink(item,currentID)" class="item" :style="{ width: getWidth }" :title="this.titleTooltip" ><img v-if="item.icon_url" class="iconurl" :src="item.icon_url"><span v-html="item.text"></span></div>' +
    '</div>' +

    '</div>',
  // template: '<div>test{{this.msg}}</div> ',
  data: function () {
    return {
      isActive: false,
      prepend: false,
      nodoComplete: false,
      currentID: null,
      truncateCharacter: 17,
      pagination: true,
      swipeNext: true,
      swipePrev: true,
      mediaUrl: null,
      nodoMenu: null,
      thumb: false,
      templateSlider: false,
      templateMenu: false,
      titTooltip: '',
      btTooltip: ',',
      getWidth: "100%",
      nodoMenuObject: [],
      currentTitle: null,
      oneItem: false,
      heightImg: 100,
      imgCustomer: this.options.imgCustomer,
      imgAgent: this.options.imgAgent,
      imgFailCustomer: this.options.imgFailCustomer,
      imgFailAgent: this.options.imgFailAgent,
      timeShow: true,
      maxWordLen: -1,
      swiperTmp: null,
      optionSliderMenu: {
        pagination: '.swiper-pagination2',
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 5,
        simulateTouch: false,
        nextButton: '.swiper-button-next2',
        prevButton: '.swiper-button-prev2',
        breakpoints: {
          // when window width is <= 320px
          420: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          // when window width is <= 640px
          640: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          1600: {
            slidesPerView: 3,
            spaceBetween: 20
          },
        }
      }


    }
  },
  created: function () {
    this.checkTemplate();
    this.checkElement();
  },
  mounted: function () {
    this.$nextTick(function () {
      var elId = "#" + this.currentID;
      if (!this.oneItem) { // if more item init swiper
        var swiper2 = new Swiper(elId, this.optionSliderMenu);
        this.swiperTmp = swiper2;
      }
    })
  },
  filters: {
    truncateTitle: function (value) {
      var text = value;
      if (value.length > this.truncateCharacter) {
        text = text.substr(0, this.truncateCharacter - 3) + "...";
        this.titleTooltipTit = value;
      }
      return text;
    },
    truncateCaption: function (value) {
      var text = value;
      if (value.length > this.truncateCharacter) {
        text = text.substr(0, this.truncateCharacter - 3) + "...";
        //  this.titleTooltipBt = value;
      }
      return text;
    },
    checkIfImgBase64: function (img) {
      if (img.indexOf("base64") != -1) {
        return false;
      }
      return img;
    }
  },
  methods: {
		svgOnError:function(){
			console.log('Fail to load svg nodo menu');
		},
    getNodo: function () {
      return this.nodoMenu["options"]
    },
    getImgAgent: function (val) {
      if (val == "virtual") {
        return this.options.imgVirtualAgent;
      } else {
        return this.options.imgAgent;
      }
    },
    setClassAgent:function(val){
      return val;
    },
    hasImgLink: function (img) {
      if (img) {
        if (img.indexOf("base64") != -1) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    },
    getHeightImg: function (url) {
      return {
        'height': this.heightImg + 'px'
      }
    },
    getUrlBgImg: function (url) {
      return {
        'background-image': 'url("' + url + '")'
      }
    },
    lenNodo: function () {
      if (this.isDefined(this.getNodo())) {
        return this.getNodo().length
      }
    },
    checkElement: function (item) {
      if (this.currentnodo.msg.options != undefined && this.currentnodo.msg.options.length == 1) {
        this.oneItem = true;
        this.resetSlider();
      }
    },
    resetSlider: function () {
      this.pagination = false;
      this.swipeNext = false;
      this.swipePrev = false;
      this.optionSliderMenu.slidesPerView = 1;
      this.optionSliderMenu.breakpoints = {
        // when window width is <= 320px
        420: {
          slidesPerView: 1
        },
        // when window width is <= 640px
        640: {
          slidesPerView: 1
        },
        1600: {
          slidesPerView: 1
        },
      }
    },
    callLink: function (item, currentNodo) {
      var currentLink;
      if (!item.text) {
        currentLink = item.caption;
      } else {
        currentLink = item.text;
      }
      $("#" + currentNodo).remove();
      bus.$emit('newMessage', {msg: currentLink, from: "menu"});

    },
    calcWidthButton: function (LenNodoObject) {
      var setWidth = "90%";

   /*   if (LenNodoObject == 3  ) {
        setWidth = "30%";
      }
      if (LenNodoObject == 4) {
        setWidth = "33%";
      }
      if (LenNodoObject >= 5 && LenNodoObject < 10) {
        setWidth = "33%";
      }
      if (LenNodoObject > 10) {
        setWidth = "14%";
      }
      if (LenNodoObject == 2 || this.maxWordLen > 8) {
        setWidth = "40%";
      }
      if (LenNodoObject == 1 || this.maxWordLen > 12 ) {
        setWidth = "80%";
      } */


      return setWidth;

    },
    findLongestWord: function (str) {
      var strSplit = str.split(' ');
      var longestWord = 0;
      for (var i = 0; i < strSplit.length; i++) {
        if (strSplit[i].length > longestWord) {
          longestWord = strSplit[i].length;
        }
      }
      return longestWord;
    },
    checkTemplate: function () {
      // $(".box-nodo-menu").remove(); // TODO
      var that = this;
      this.isActive = true;
      this.nodoMenu = this.currentnodo.msg;
      this.currentID = Date.now();
      this.nodoMenuObject = this.getNodo();
      var len = this.lenNodo();

      if (this.nodoMenuObject) {
        var i = 0;
        while (i < len) {
          var currentNode = this.nodoMenuObject[i];
          this.currentTitle = currentNode.text;
          this.maxWordLen = Math.max(this.maxWordLen, this.findLongestWord(this.currentTitle));
          var image_url = currentNode.image_url;
          if (image_url) {
            this.templateSlider = true;
            break;
          }
          i += 1;
        }
        if (i === len) { // se fino alla fine non trovo immmagini faccio il template menu
          this.templateMenu = true;

        }
      };
      this.build();
    },
    getDocumentWidth: function () {
      return document.body.offsetWidth;
    },
    matchHeight: function () {
      this.$nextTick(function () {
        $('.box-nodo-menu .item').matchHeight();
      })
    },
    build: function () {
      var win = this.getDocumentWidth();

      if (win <= 360) {
        this.truncateCharacter = 30;
      } else {
        this.truncateCharacter = 17;
      };

      this.getWidth = this.calcWidthButton(this.lenNodo());
      if (this.templateMenu) {
        this.matchHeight();
      }
    },
    getId: function () {
      return this.currentID;
    },
    isDefined: function (item) {
      return typeof item != typeof undefined && item != null;
    },

  }
})
